"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var BaseChartConfigurationPanel_1 = tslib_1.__importDefault(require("./BaseChartConfigurationPanel"));
var axis_1 = require("../../constants/axis");
var BarChartConfigurationPanel = /** @class */ (function (_super) {
    tslib_1.__extends(BarChartConfigurationPanel, _super);
    function BarChartConfigurationPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BarChartConfigurationPanel.prototype.getAxesConfiguration = function (type) {
        return axis_1.BAR_CHART_AXIS_CONFIG[type];
    };
    return BarChartConfigurationPanel;
}(BaseChartConfigurationPanel_1.default));
exports.default = BarChartConfigurationPanel;
//# sourceMappingURL=BarChartConfigurationPanel.js.map